cgnom
<template>
    <div>
        <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">调拨单信息</div>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>基本信息</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>调拨单号</span></div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.innerNo || '无' }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>记账凭证号</span></div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.reservedNo || '无' }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>调拨总数量</span></div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.totalQuantity || '无' }}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>调拨净值总额</span></div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.totalNetWorth || '无' }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">创建机构</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.creatorComName }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">申请人</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.applicantName }}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>申请人电话</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.applicantContactTel }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item" style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">调出机构</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.srcComFullName }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item" style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>调出机构编码</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.srcBizUnitCode }}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item" style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>调出成本中心</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.srcCostCenterCode }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item" style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>调出利润中心</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.srcPrftCenterCode }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item" style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">调入机构</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.dstComFullName }}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item" style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>调入机构编码</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.dstBizUnitCode }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item" style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>调入成本中心</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.dstCostCenterCode }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item" style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>调入利润中心</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.dstPrftCenterCode }}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item" style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">调拨日期</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.createTime }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item" style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">申请日期</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.applyTime }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item" style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">生凭时间</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.ledgerTime }}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>申请原因</span></div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.applyDesc }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>备注说明</span></div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{ shopDeviceTransVoucher.memo }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 54px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">&nbsp;</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>&nbsp;</span>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <template v-if="!shopDeviceTransVoucher.suitFlag">
            <template v-if="deviceItemList != null && deviceItemList.length > 0">
                <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">单品式管理</div>
                <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;padding:5px 2px 10px 2px;" v-for="deviceItem in deviceItemList">
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;
word-wrap:break-word;">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>资产编号</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.innerCode }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>资产描述全称</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.title }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>规格</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.fixedSpec || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>资产属性</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ assetNatureMap[deviceItem.assetNature] }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>是否在账</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.fiscalAcctFlag ? '是' : '否' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>数量</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.quantity }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>单位</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.theUnit }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>原值(元)</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="deviceItem.orgWorth != null">{{ deviceItem.orgWorth.toFixed(2) }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>净值(元)</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="deviceItem.netWorth != null">{{ deviceItem.netWorth.toFixed(2) }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>累计折旧(元)</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="deviceItem.aggtDeprWorth != null">{{ deviceItem.aggtDeprWorth.toFixed(2) }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调入机构</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="deviceItem.dstMerchantId != deviceItem.retailerId && deviceItem.dstMerchantName != null">{{ deviceItem.dstMerchantName }}</span>
                            <span v-if="deviceItem.dstMerchantId != deviceItem.retailerId && deviceItem.dstMerchantName != null && deviceItem.dstBizUnitName != null">/</span>
                            <span v-if="deviceItem.dstBizUnitName != null">{{ deviceItem.dstBizUnitName }}</span>
                            <span v-if="deviceItem.dstBizUnitName != null && deviceItem.dstComName != null && deviceItem.dstBizUnitName != deviceItem.dstComName">/{{ deviceItem.dstComName }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调入机构编号</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.dstComNo || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调入成本中心</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.dstCostCenterCode || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调入资产编号</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.dstInnerCode || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调出部门</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.srcComName || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调出公司编码</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.srcRealComCode || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调出成本中心</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.srcCostCenterCode || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>税率(%)</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="deviceItem.taxRate != null">{{ deviceItem.taxRate.toFixed(2) }}</span>
                            <span v-else>0</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>备注</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.memo || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>系统编号</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.tmpNo || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>记账凭证号</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ deviceItem.reservedNo || '' }}</span>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="durableItemList != null && durableItemList.length > 0">
                <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">
                    <span>{{ shopDeviceTransVoucher.assetType != 2 ? '批量式管理' : '耗材管理' }}</span>
                </div>
                <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;" v-for="durableItem in durableItemList">
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px; word-break:break-all;word-wrap:break-word;">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>资产编号</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.innerCode }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>资产描述全称</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.title }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>规格</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.fixedSpec || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>资产属性</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ assetNatureMap[durableItem.assetNature] }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>是否在账</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.fiscalAcctFlag ? '是' : '否' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调拨数量</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.quantity }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>含报废数量</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.quantity2 }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>单位</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.theUnit }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>原值(元)</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="durableItem.orgWorth != null">{{ durableItem.orgWorth.toFixed(2) }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>净值(元)</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="durableItem.netWorth != null">{{ durableItem.netWorth.toFixed(2) }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>累计折旧(元)</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="durableItem.aggtDeprWorth != null">{{ durableItem.aggtDeprWorth.toFixed(2) }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调入机构</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="durableItem.dstMerchantId != durableItem.retailerId && durableItem.dstMerchantName != null">{{ durableItem.dstMerchantName }}</span>
                            <span v-if="durableItem.dstMerchantId != durableItem.retailerId && durableItem.dstMerchantName != null && durableItem.dstBizUnitName != null">/</span>
                            <span v-if="durableItem.dstBizUnitName != null">{{ durableItem.dstBizUnitName }}</span>
                            <span v-if="durableItem.dstBizUnitName != null && durableItem.dstComName != null && durableItem.dstBizUnitName != durableItem.dstComName">/{{ durableItem.dstComName }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调入机构编号</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.dstComNo || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调入成本中心</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.dstCostCenterCode || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调入资产编号</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.dstInnerCode || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调出部门</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.srcComName || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调出公司编码</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.srcRealComCode || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>调出成本中心</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.srcCostCenterCode || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>税率(%)</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span v-if="durableItem.taxRate != null">{{ durableItem.taxRate.toFixed(2) }}</span>
                            <span v-else>0</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>备注</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.memo || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>系统编号</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.tmpNo || '' }}</span>
                        </div>
                    </div>
                    <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                        <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                            <label>记账凭证号</label>
                        </div>
                        <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                            <span>{{ durableItem.reservedNo || '' }}</span>
                        </div>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">套装明細</div>
            <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;" v-for="deviceItem in deviceItemList">
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>设备名称</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{ deviceItem.title }}</div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>系统编号</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{ deviceItem.tmpNo }}</div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>是否主资产</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ deviceItem.suitMainFlag ? '是' : '否' }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>套装编号</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{ deviceItem.suitNo }}</div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>设备分类</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{ deviceItem.catName }}</div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>分类分组</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ getDevcGroupNameByCatId(deviceItem.catId) }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>设备品牌</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ deviceItem.brandName }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>设备型号</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ deviceItem.model || '' }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>设备规格</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ deviceItem.fixedSpec || '' }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>调出部门</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ deviceItem.srcComName }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>调出仓库</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ deviceItem.srcWarehouseName }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>调入部门</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ deviceItem.dstComName }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>调入仓库</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ deviceItem.dstWarehouseName }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>核实类型</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ allotAcntTypeMap[deviceItem.allotAcntType] }}</span>
                    </div>
                </div>
            </div>
        </template>
        <!--OA审批-->
        <template v-if="auditRecList != null && auditRecList.length > 0 && shopDeviceTransVoucher.outerAuditFlag">
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">审核记录</div>
            <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;padding:5px 2px 10px 2px;" v-for="auditRecInfo in auditRecList">
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;
word-wrap:break-word;">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>审批环节</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ auditRecInfo.nodeName }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>审核人</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ auditRecInfo.auditorName }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>审核状态</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span v-if="auditRecInfo.nodeName != '提报'">
                            <span>{{ auditRecInfo.auditStatusStr || '' }}</span>
                        </span>
                        <span v-else>已提报</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>审核描述</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ auditRecInfo.auditDesc || '' }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>是否终审</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span v-if="auditRecInfo.finalNodeFlag">是</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>审核时间</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ auditRecInfo.ts }}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="deviceRecList != null && deviceRecList.length > 0 && !shopDeviceTransVoucher.outerAuditFlag">
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">审核记录</div>
            <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;padding:5px 2px 10px 2px;" v-for="auditRecInfo in deviceRecList">
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px;word-break:break-all;
word-wrap:break-word;">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>操作所属部门</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ auditRecInfo.retailerComName }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>操作时间</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ auditRecInfo.ts }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>操作</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ auditRecInfo.action || '' }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>操作业务单元</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ auditRecInfo.retailerBizUnitName }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>岗位</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ auditRecInfo.actRole }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>操作人</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ auditRecInfo.actorName }}</span>
                    </div>
                </div>
                <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                    <div style="width: 54px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                        <label>操作描述</label>
                    </div>
                    <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                        <span>{{ auditRecInfo.extraInfo }}</span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'
//
import { getDevcGroupNameByCatId } from '../index'
import { showHtmlToPdfDlg } from '../ctrl/dialog'
//
import shopDevcApi from '../../api/shopDevc'
import assetVchrApi from '../../api/assetVchr'
import oaAuditApi from '../../api/oaAudit'

export default {
    name: 'swb-shop-device-trans-voucher-for-pdf',
    desc: '调拨单导出',
    props: {
        voucherId: {
            type: Number,
            deafult: null,
        },
    },
    data: function () {
        return {
            shopDeviceTransVoucher: {},
            deviceItemList: [],
            durableItemList: [],
            allotAcntTypeMap: getEnumMap('allotAcntType', 'value2text'),
            assetNatureMap: getEnumMap('assetNature', 'value2text'),
            ledgerStateMap: getEnumMap('ledgerState', 'value2text'),
            //
            auditRecList: [],
            deviceRecList: [],
        }
    },
    created: function () {
        this.getShopDeviceTransVouhcer();
    },
    methods: {
        getDevcGroupNameByCatId(catId) {
            return getDevcGroupNameByCatId(catId);
        },
        getShopDeviceTransVouhcer: function () {
            let self = this;
            let postData = {};
            postData.id = self.voucherId;
            let theLoading = MsgBox.loading();
            assetVchrApi.getShopDeviceTransVoucherById(postData, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    let shopDeviceTransVoucher = result.data;
                    self.shopDeviceTransVoucher = shopDeviceTransVoucher;
                    self.deviceItemList = shopDeviceTransVoucher.deviceItemList;
                    self.durableItemList = shopDeviceTransVoucher.durableItemList;
                    //
                    if(shopDeviceTransVoucher.outerAuditFlag && shopDeviceTransVoucher.applyState != 0) {
                        self.getMerchtAuditBpRecsByBizVoucherNo(shopDeviceTransVoucher.no, shopDeviceTransVoucher.auditSeqNo, shopDeviceTransVoucher.innerNo);
                    } else {
                        self.getShopDeviceRecNotPageList(shopDeviceTransVoucher.no);
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        // 审核记录
        getMerchtAuditBpRecsByBizVoucherNo: function (bizVoucherNo, auditSeqNo, innerNo) {
            let self = this;
            if(!Utils.isNoB(innerNo)) {
                bizVoucherNo = innerNo;
            }
            let params = {
                bizVoucherNo: bizVoucherNo,
                bizTypeCode: 'retailer.assets.allot',
                auditSeqNo: auditSeqNo,
            };
            let theLoad = MsgBox.loading();
            oaAuditApi.getMerchtAuditBpRecsByBizVoucherNo(params, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    self.auditRecList = result.data || [];
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getShopDeviceRecNotPageList: function (bizVoucherNo) {
            let self = this;
            let params = {
                srcVoucherType: 3,
                srcVoucherNo: bizVoucherNo
            };
            let theLoad = MsgBox.loading();
            shopDevcApi.getShopDeviceRecNotPageList(params, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    self.deviceRecList = result.data || [];
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
//            exportPdf: function () {
//                let self = this;
//                let result = self.$refs.swb_servc_work_add_item_list.getHtml() || '';
//                showHtmlToPdfDlg(self.title, result, null);
//            },
        getHtml: function () {
            return this.$el.outerHTML;

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransVoucherForPdf.vue